import styled, { css } from 'styled-components';

import {
    colors,
    ColorsTransparencies,
    FontColorProps,
    setFontColor,
    spacing,
    transparencies,
} from 'styles/theme';

export const SelectWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export interface SelectProps extends FontColorProps {
    $backgroundColor?: ColorsTransparencies;
}

export const Select = styled.select<SelectProps>`
    outline: none;
    border: 1px solid ${transparencies.darkJungle5};
    border-radius: ${spacing.radiusSmall};
    background-color: ${colors.white};
    width: 100%;
    padding: ${spacing.xSmall} ${spacing.xSmall};
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
    ${setFontColor}

    &:focus {
        border-color: ${colors.focus};
    }

    ${({ $backgroundColor }) =>
        $backgroundColor &&
        css`
            background-color: ${$backgroundColor};
        `}
`;

export const DropdownArrowWrapper = styled.div`
    position: absolute;
    // Custom absolute positioning for symmetry
    bottom: 9px;
    right: ${spacing.small};
    pointer-events: none;
    transform: rotate(90deg);
`;
